import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgImportErrorFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 2H22V22H2V2ZM16.4242 7.57564C16.6585 7.80995 16.6585 8.18985 16.4242 8.42417L12.8484 11.9999L16.4242 15.5756C16.6585 15.81 16.6585 16.1899 16.4242 16.4242C16.1899 16.6585 15.81 16.6585 15.5756 16.4242L11.9999 12.8484L8.42417 16.4242C8.18985 16.6585 7.80995 16.6585 7.57564 16.4242C7.34132 16.1899 7.34132 15.81 7.57564 15.5756L11.1514 11.9999L7.57564 8.42417C7.34132 8.18985 7.34132 7.80995 7.57564 7.57564C7.80995 7.34132 8.18985 7.34132 8.42417 7.57564L11.9999 11.1514L15.5756 7.57564C15.81 7.34132 16.1899 7.34132 16.4242 7.57564Z",
		fill: "currentColor"
	})
});
export default SvgImportErrorFilled;
